<template>
  <article class="flex w-full" data-component="CardCollection">
    <AtomLink :url="url" class="flex flex-col w-full rounded-2xl shadow-md hover:shadow-none focus:shadow-none transition duration-200 cursor-pointer group">
      <div
        class="flex flex-col flex-auto relative p-3 md:p-6 bg-app-primary-1-red--torch group-hover:bg-black group-focus:bg-black rounded-br-2xl rounded-bl-2xl overflow-hidden z-0 transition duration-300 v-gradient-card-collection order-2"
      >
        <div class="flex flex-auto justify-center relative mb-3 md:mb-6 pt-1 z-10 text-center">
          <h3 class="text-base md:text-xl xl:text-3xl text-white font-normal leading-tight">{{ title }}</h3>
        </div>
        <div class="flex justify-center">
          <MoleculeButton
            v-if="buttonText"
            :enable-icon-left="false"
            size="medium"
            class="md:hidden group-hover:bg-app-primary-1-red--fire-brick group-focus:bg-app-primary-1-red--fire-brick w-fit z-10"
          >
            {{ buttonText }}
          </MoleculeButton>
          <MoleculeButton
            v-if="buttonText"
            :enable-icon-left="false"
            size="x-large"
            class="hidden md:flex group-hover:bg-app-primary-1-red--fire-brick group-focus:bg-app-primary-1-red--fire-brick w-fit z-10"
          >
            {{ buttonText }}
          </MoleculeButton>
        </div>
      </div>
      <div class="relative rounded-tr-2xl rounded-tl-2xl overflow-hidden order-1">
        <MoleculePicture v-if="image" class="block w-full transition duration-1000 group-hover:scale-105 group-focus:scale-105 object-cover" :image="image" :aria-hidden="true" />
      </div>
    </AtomLink>
  </article>
</template>

<script setup lang="ts">
defineProps({
  title: { type: String, required: true },
  image: {
    type: Object as PropType<Record<string, any>>,
    required: false,
    default: () => ({
      _xsUrl: '/images/fallback/608x414.png',
      _xsWidth: 608,
      _xsHeight: 414,
      _smUrl: '/images/fallback/350x238.png',
      _smWidth: 350,
      _smHeight: 238,
    }),
  },
  url: { type: String, required: true },
  buttonText: { type: String, required: true },
})
</script>

<style lang="scss" scoped>
.v-gradient-card-collection {
  &::after {
    @apply absolute block w-full h-full left-0 bottom-0 z-0;
    content: '';
    background:
      radial-gradient(circle at 5% 95%, rgba(0, 79, 89, 0.3) 0%, theme('colors.transparent') 90%),
      radial-gradient(circle at 95% 5%, rgba(0, 79, 89, 0.1) 0%, theme('colors.transparent') 50%);
  }
}
</style>
